import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Login,
  Custom,
  Container
} from '@app/shared';


@Injectable()
export class CreateUserLoginFormService {
  constructor() {}

  /**
   * Retorna el formulario de edicion de login
   *
   * @param {*} options
   * @param {*} template
   * @param {Login} [userLogin]
   * @returns {BaseControl<any>[]}
   * @memberof CreateUserLoginFormService
   */
  getFieldsCompensaciones(
    options: any,
    template: any,
    userLogin?: Login
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtUserName',
        type: 'text',
        label: 'Nombre de usuario:',
        placeholder: 'Ingrese el nombre de usuario para la autenticacion',
        value: userLogin ? userLogin.username : null,
        order: 1,
        validations: {
          validators: [Validators.required, Validators.pattern('^[a-z0-9_\-\\_\ü]+$')],
          messages: {
            pattern: 'El nombre de usuario no puede contener letras mayusculas ni caracteres especiales ' +
                     'a excepción de guiones (-) o guiones bajos (_)'
          }
        }
      }),
      new Custom({
        key: 'cboGroups',
        label: 'Grupos:',
        template: template['ngMultiSelect'],
        value: userLogin ? userLogin['groups_user'] ? userLogin['groups_user'] : null : null,
        options: options ? options['optionRoles'] ? options['optionRoles'] : [] : [],
        placeholder: 'Seleccione los grupos que pertenece el usuario',
        order: 2,
      }),
      new Container({
        class: 'form-row',
        order: 3,
        controls: [
          new Custom({
            key: 'cboCompany',
            label: 'Empresa:',
            template: template['ngSelect'],
            value: userLogin ? userLogin.empresa ? userLogin.empresa.id : 1 : 1,
            options: options ? options['optCompanies'] ? options['optCompanies'] : [] : [],
            placeholder: 'Seleccione la empresa donde pertenece el usuario',
            disabled: true,
            size: 'col-12 col-md-6',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'cboCharge',
            label: 'Cargo:',
            template: template['ngSelect'],
            value: userLogin ? userLogin.cargo ? userLogin.cargo.id : null : null,
            options: options ? options['optCharges'] ? options['optCharges'] : [] : [],
            placeholder: 'Seleccione el cargo del usuario',
            size: 'col-md-6 col-12',
            validations: {
              validators: [Validators.required],
            },
          }),
          new Custom({
            key: 'cboSede',
            label: 'Dependencia:',
            template: template['ngSelect'],
            value: userLogin ? userLogin.sede ? userLogin.sede.id : null : null,
            options: options ? options['optSedes'] ? options['optSedes'] : [] : [],
            placeholder: 'Seleccione la sede donde pertenece el usuario',
            size: 'col-12',
            validations: {
              validators: [Validators.required]
            },
            condictions: [{
              campoDepende: 'cboCompany',
              siEs: 'Vacio',
              accion: 'Bloquear'
            }],
          }),
        ]
      }),
      new Container({
        class: 'form-row',
        order: 4,
        controls: [
          new Textbox({
            key: 'chActive',
            type: 'checkbox',
            value: userLogin ? userLogin.is_active : true,
            label: 'Activo',
            size: 'col-2',
          }),
          new Custom({
            key: 'btnChangePassword',
            template: template['tplChangePassword'],
            size: 'col-10 text-right',
          }),
        ]
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/create-user-login/shared/create-user-login.form.service.ts